module.exports = __webpack_public_path__ + "img/emptyStateHistoryConection.76d29557.svg";